import React from "react";
import Seo from "@/components/Seo";
import ServiceHero from "@/components/marketing/service/ServiceHero";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { BookOpen, GraduationCap, CalendarDays, LifeBuoy, ArrowRight } from "lucide-react";

const RESOURCES = [
  {
    icon: GraduationCap,
    name: "How It Works",
    path: "/how-it-works",
    desc: "The end-to-end process, from your brief to published coverage across every channel.",
  },
  {
    icon: BookOpen,
    name: "Guides",
    path: "/guides",
    desc: "In-depth guides on PR, SEO, digital media, and getting your brand mentioned in AI search.",
  },
  {
    icon: CalendarDays,
    name: "Editorial Calendar",
    path: "/editorial-calendar",
    desc: "Plan your PR and content around the moments, seasons, and events that matter to your audience.",
  },
  {
    icon: LifeBuoy,
    name: "Help Centre",
    path: "/help",
    desc: "Answers to common questions about orders, distribution, and your account.",
  },
];

export default function ResourcesOverview() {
  return (
    <div className="bg-canvas">
      <Seo title="Resources | Digital24" />
      <ServiceHero
        eyebrow="RESOURCES"
        title="Everything you need to plan, publish, and get found."
        subtitle="Guides, process explainers, an editorial calendar, and a help centre — all the resources to help you get the most from Digital24."
        primaryCTA={{ label: "Browse Guides", to: "/guides" }}
        secondaryCTA={{ label: "Contact Us", to: "/contact" }}
      />
      <section className="py-7 sm:py-9 lg:py-12">
        <Container>
          <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {RESOURCES.map((r) => (
              <Link key={r.name} to={r.path} className="group bg-white border border-[#e8e6ef] rounded-xl p-8 flex flex-col hover:border-cobalt/40 hover:shadow-sm transition-all">
                <div className="w-11 h-11 rounded-lg bg-cobalt/10 flex items-center justify-center mb-5">
                  <r.icon className="w-5 h-5 text-cobalt" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-bone mb-3">{r.name}</h3>
                <p className="text-sm text-steel leading-relaxed mb-6 flex-1">{r.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-cobalt">
                  Open <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}